module.exports = __webpack_public_path__ + "static/media/ec.ce7ff656.png";